import React from 'react';
import { Link } from 'react-router-dom';
import './ProductIdeationCard.css';

const ProductIdeationCard = ({ title, cards }) => {
  return (
    <div className="ideation-card-container">
      <h2 className="ideation-title">{title}</h2>
      <div className="ideation-columns">
        {cards.map((item, index) => (
          <div className="ideation-column" key={index}>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>

            {item.route && (
              <Link to={item.route} className="ideation-footer">
                <span className="ideation-footer-text">
                  <span className="arrow">{'\u2192'}</span>
                  <span className="explore">Explore</span>
                </span>
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductIdeationCard;
